export default __webpack_public_path__ + "static/media/2020_exterior4.461effd7.jpeg";